import React, { useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { RiCloseLine } from 'react-icons/ri';
import NewsletterForm from '../../NewsletterForm/NewsletterForm';
import styles from './NewsletterModal.module.scss';
import { getSiteUiFromPath, getLanguageFromPath } from '../../../lib/polylang';

const NewsletterModal = ({ isOpen, onClose }) => {
  const router = useRouter();
  const ui = getSiteUiFromPath(router.asPath);
  const isEn = getLanguageFromPath(router.asPath).code === 'en';
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      modalRef.current?.focus();
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContent} ref={modalRef}>
        <button className={styles.closeButton} onClick={handleClose} aria-label={ui.close}>
          <RiCloseLine />
        </button>

        <div className={styles.modalBody}>
          <div className={styles.header}>
            <h2 className={styles.title}>
              {isEn ? 'Sign up for our newsletter' : 'Meld deg på vårt nyhetsbrev'}
            </h2>
            <p className={styles.description}>
              {isEn
                ? 'Want to be notified when we publish articles? Sign up for the newsletter below and you will receive an email every time we publish new articles.'
                : 'Ønsker du å bli varslet når vi legger ut artikler? Meld deg på nyhetsbrevet nedenfor, så vil du motta e-post hver gang vi legger ut nye artikler.'}
            </p>
          </div>

          <NewsletterForm className={styles.newsletterForm} />
        </div>
      </div>
    </div>
  );
};

export default NewsletterModal;

